module.exports = require("linkifyjs/string");